import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import homePage from '../views/homePage.vue'   
import atlas from '../views/atlas/atlas.vue'
import atlasWx from '../views/atlas/atlas_wx.vue'
import login from '../views/login'  
import { Message } from 'element-ui';
import axios from 'axios'; 
import {getCookieInfo} from '../io/getCookie.js'  
//cookies里的access_token=localStorage.token;
Vue.prototype.$http = axios
Vue.prototype.$message = Message;
Vue.use(VueRouter)

const routes = [
	{
		path: '/login',
		name: 'login',
		component: login,
		meta: { title: '登录', requiredLogin: false, hideHeader:true}
	},
	{
		path:'/',
		redirect:'/homePage'
	},
	{
		path: '/homePage',
		name: 'homePage',
		component: homePage,
		meta: { title: '首页', requiredLogin: false }//hideHeader:true 
	}, 
	{
		path: '/globalHotWord',
		name: 'globalHotWord',
		component: () => import('../views/global_hotWord.vue') ,
		meta: { title: '', requiredLogin: false}//hideHeader:true 
	}, 
	{
		path: '/aiAnswer',
		name: 'aiAnswer',
		component: () => import('../views/ai_answer/ai_answer.vue') ,
		meta: { title: 'AI问答', requiredLogin: true}//hideHeader:true 
	},
	{
		path: '/intellAnswer',
		name: 'intellAnswer',
		component: () => import('../views/ai_answer/intell_answer.vue') ,
		meta: { title: '智能养生问答', requiredLogin: true}//hideHeader:true 
	}, 
    {
		path: '/academicAnalysis',
		name: 'academicAnalysis',
		component: () => import('../views/academicAnalysis.vue') ,
		meta: { title: '学术分析', requiredLogin: true}//hideHeader:true 
	},
    {
		path: '/analysisJg',
		name: 'analysisJg',
		component: () => import('../views/academicAnalysis/analysisJg.vue') ,
		meta: { title: '机构分析', requiredLogin: true}//hideHeader:true 
	},
    {
		path: '/analysisXk',
		name: 'analysisXk',
		component: () => import('../views/academicAnalysis/analysisXk.vue') ,
		meta: { title: '学科分析', requiredLogin: true}//hideHeader:true 
	},
	{
		path: '/customizeInfo',
		name: 'customizeInfo',
		component: () => import('../views/customize_info/customize_info.vue') ,
		meta: { title: '定制服务介绍', requiredLogin: true}//hideHeader:true 
	}, 
    {
		path: '/customizeIframe',
		name: 'customizeIframe',
		component: () => import('../views/customize_info/custimizeIframe.vue') ,
		meta: { title: '定制服务图谱', requiredLogin: true}//hideHeader:true 
	}, 
	{
		path: '/attachmentPdf',
		name: 'attachmentPdf',
		component: () => import('../views/customize_info/attachmentPdf.vue') ,
		meta: { title: '', requiredLogin: true}//hideHeader:true 
	},  
	// 老版本里的知识图谱http://www.tcmkb.cn/pages/clinic_zhishitupu.jsp
	// {
	// 	path:'/knowledgeGraph',
	// 	name: 'knowledgeGraph',
	// 	component: () => import('../views/homePage/knowledge_graph/knowledge_graph.vue') ,
	// 	meta: { title: '知识图谱', requiredLogin: false }
	// },
	{
		path:'/recognizeFj',
		name: 'recognizeFj',
		component: () => import('../views/recognize_fj/recognize_fj.vue') ,
		meta: { title: '方剂识别', requiredLogin: true }
	},
	{
		path:'/bibliometric',
		name: 'bibliometric',
		component: () => import('../views/bibliometric.vue') ,
		meta: { title: '文献计量分析', requiredLogin: true,}
	}, 
	{
		path:'/bibliometricAnalysis',
		name: 'bibliometricAnalysis',
		component: () => import('../views/bibliometric/bibliometric_analysis.vue') ,
		meta: { title: '文献计量分析', requiredLogin: true,}
	}, 
	{
		path:'/bibliometricDetails',
		name: 'bibliometricDetails',
		component: () => import('../views/bibliometric/bibliometric_details.vue') ,
		meta: { title: '文献计量分析详情', requiredLogin: true ,}
	},
	{
		path:'/atlasResult',
		name: 'atlasResult',
		component: () => import('../views/bibliometric/atlas_result.vue') ,
		meta: { title: '文献计量分析图谱', requiredLogin: true,}
	},
	{
		path:'/atlas',
		name: 'atlas',
		component:atlas ,
		meta: { title: '知识图谱', requiredLogin: true ,}
	}, 
	/*外部访问不展示header 与 foorter*/
	{
		path:'/bibliometricOut',
		name: 'bibliometricOut',
		component: () => import('../views/bibliometric.vue') ,
		meta: { title: '文献计量分析', requiredLogin: false,hideHeader:true }
	}, 
	{
		path:'/bibliometricDetailsOut',
		name: 'bibliometricDetailsOut',
		component: () => import('../views/bibliometric/bibliometric_details.vue') ,
		meta: { title: '文献计量分析详情', requiredLogin: false ,hideHeader:true}
	}, 
	{
		path:'/atlasOut',
		name: 'atlasOut',
		component:atlas ,
		meta: { title: '知识图谱', requiredLogin: false ,hideHeader:true }
	}, 

	{
		path:'/atlasWx',
		name: 'atlasWx',
		component:atlasWx ,
		meta: { title: '文献大数据平台知识图谱自动抽取系统', requiredLogin: false ,hideHeader:true }
	},

	/* 首页相关end ---- ---- */
    {
        path:'/hotNewsDetails',
        name: 'hotNewsDetails',
        component: () => import('../views/hotNewsDetails.vue') ,
        meta: { title: '热点新闻详情', requiredLogin: false }
    },
    {
        path:'/hotNewsList',
        name:'hotNewsList',
        component: () => import('../views/hotNewsList.vue') ,
        meta: { title: '热点新闻', requiredLogin: false }
    },
	
	{
		path: '/pill',
		name: 'pill',
		component: () => import('../views/pill.vue') ,
		meta: { title: '', requiredLogin: true}//hideHeader:true 
	}, 
	{
		path:'/studyPage',
		name: 'studyPage', 
		component: () => import( '../views/studyPage/studyPage.vue') ,
		meta: { title: '学古籍', requiredLogin: true }, 
	},
	{
		path:'/bookCatalogue',
		name: 'bookCatalogue',
		component: () => import('../views/studyPage/book_catalogue.vue') ,
		meta: { title: '古籍详情', requiredLogin: true }
	},
	{
		path:'/bookDetails',
		name: 'bookDetails',
		component: () => import('../views/bookDetails.vue') ,
		meta: { title: '古籍详情', requiredLogin: true }
	},
	{
		path:'/articleDetails',
		name: 'articleDetails',
		component: () => import('../views/articleDetails.vue') ,
		meta: { title: '古籍详情', requiredLogin: true }
	},
	 
	{
		path: '/resourcePage',
		name: 'resourcePage',
		component: () => import('../views/resource/resource_page.vue') ,
		meta: { title: '特色资源', requiredLogin: true}//hideHeader:true 
	},
	{
		path:'/resourceList',
		name: 'resourceList',
		component: () => import('../views/resource/resource_list.vue') ,
		meta: { title: '特色资源', requiredLogin: true }
	},
	{
		path:'/subject',
		name: 'subject',
		component: () => import('../views/subject/subject.vue') ,
		meta: { title: '专题服务', requiredLogin: true }
	},
	{
		path:'/subjectLiterature',
		name: 'subjectLiterature',
		component: () => import('../views/subject_pgae/subject_literature.vue') ,
		meta: { title: '伤寒论专题', requiredLogin: true }
	}, 
    {
		path:'/studyMore',
		name: 'studyMore',
		component: () => import('../views/studyPage/studyMore.vue') ,
		meta: { title: '查看更多', requiredLogin: true }
	},
	{
		path:'/studyDetails',
		name: 'studyDetails',
		component: () => import('../views/studyPage/studyDetails.vue') ,
		meta: { title: '列表页', requiredLogin: true }
	}, 
	{
		path:'/studyTopicDetails',
		name: 'studyTopicDetails',
		component: () => import('../views/studyPage/studyTopicDetails.vue') ,
		meta: { title: '题库列表页', requiredLogin: true }
	}, 
    {
        path:'/detailsTopic',
        name: 'detailsTopic',
        component: () => import('../views/studyPage/detailsTopic.vue') ,
        meta: { title: '题库', requiredLogin: true }
    },
	{
		path:'/graph',
		name: 'graph',
		component: () => import('../views/echarts_graph/g6_graph.vue') ,
		meta: { title: 'graph图谱', requiredLogin: true }
	}, 
	{
		path:'/complex',
		name: 'complex',
		component: () => import('../views/bibliometric/comps/complex.vue') ,
		meta: { title: 'complex', requiredLogin: true }
	},
	// 未匹配路由：跳转首页
	{
		path: '*',
		redirect: '/homePage'
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})



router.beforeEach( (to, from, next) => {
	let token =  localStorage.getItem('token') || getCookieInfo('access_token')||''; 
	// if(to.meta.title){//判断是否有标题
	// 	document.title = '中医药知识服务平台'+to.meta.title
	// } 
	if (to.matched.some(record => record.meta.requiredLogin)) {   
		// 判断用户是否处于登录状态 
		if (!token) { 
			Message({
				message: '请先登录~',
				type: 'warning'
			}); 
			next()
			// router.push({ path: '/sign-in', query: {redirect:to.fullPath}});
			router.push({ path: '/homePage'});
		} else { 
			if (to.meta.title) {
				document.title = to.meta.title
			}
			next();
			if (token) { 
				store.commit("userToken", token)
			}
				// if (to.path === '/login') return next();
				// 	const token = sessionStorage.getItem('token')
				// 	// if (!token) return next('/index');
				// 	// next();
		}
	} else { 
		next()
	}
})
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
